module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** (webpack)-dev-server/~/socket.io-client/~/has-binary/~/isarray/index.js
 ** module id = 51
 ** module chunks = 0
 **/